module.exports = __webpack_public_path__ + "static/media/TheSeminaryOfSight.b7952240.md";